.supplier {
  background-color: var(--mantine-color-supplier-header-bg);
  color: var(--mantine-color-supplier-header-text) !important;
}

.supplier p {
  color: var(--mantine-color-supplier-header-text) !important;
}

.brand {
  background-color: var(--mantine-color-brand-header-bg);
  color: var(--mantine-color-brand-header-text);
}

.brand p {
  color: var(--mantine-color-brand-header-text);
}

.brand .nav-link {
  color: var(--mantine-color-brand-header-text);
}

.supplier .nav-link {
  color: var(--mantine-color-supplier-header-text);
}

.brand {
  color: var(--mantine-color-brand-header-text);
}

.title a {
  text-decoration: none;
  color: var(--mantine-color-text);
}
.title [data-active] {
  text-decoration: underline;
  font-weight: 500;
}
.title {
  display: block;
  line-height: 1;
  padding: rem(8px) rem(12px);
  border-radius: var(--mantine-radius-sm);
  text-decoration: none;
  color: var(--mantine-color-text);
  white-space: nowrap;
  @mixin hover {
    background-color: light-dark(
      var(--mantine-color-gray-0),
      var(--mantine-color-dark-6)
    );
  }

  [data-mantine-color-scheme] &[data-active] {
    text-decoration: underline;
    color: var(--mantine-color-green-8);
  }
}
